var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 35,
    viewBox: "0 0 26 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5795 35C19.5269 35 25.159 19.0855 25.159 12.2951C25.159 5.5047 19.5269 0 12.5795 0C5.63202 0 0 5.5047 0 12.2951C0 19.0855 5.63202 35 12.5795 35ZM12.5743 17.5416C15.5385 17.5416 17.9415 15.1929 17.9415 12.2957C17.9415 9.39848 15.5385 7.0498 12.5743 7.0498C9.61003 7.0498 7.20703 9.39848 7.20703 12.2957C7.20703 15.1929 9.61003 17.5416 12.5743 17.5416Z",
    fill: "#EA5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkIcon);
export default __webpack_public_path__ + "static/media/markIcon.2b045dffffdc17929157b7909a250822.svg";
export { ForwardRef as ReactComponent };